import { render } from "./SurveySection.vue?vue&type=template&id=12b5c58c"
import script from "./SurveySection.vue?vue&type=script&lang=js"
export * from "./SurveySection.vue?vue&type=script&lang=js"

import "./SurveySection.vue?vue&type=style&index=0&id=12b5c58c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__